import { render, staticRenderFns } from "./PrizesEditor.vue?vue&type=template&id=cdbff3fa&"
import script from "./PrizesEditor.vue?vue&type=script&lang=js&"
export * from "./PrizesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports